import { http } from '../../../../api/http';
import type { VariablePlanilla } from '../types/variable';

const ENDPOINT = '/planilla/variable';

export class VariableService {
  static async getAll(): Promise<VariablePlanilla[]> {
    const response = await http.get(ENDPOINT);
    return response.data;
  }

  static async getByCategoria(categoria: string): Promise<VariablePlanilla[]> {
    const response = await http.get(`${ENDPOINT}/categoria/${categoria}`);
    return response.data;
  }

  static async save(variable: VariablePlanilla): Promise<VariablePlanilla> {
    const response = await http.post(ENDPOINT, variable);
    return response.data;
  }

  static async delete(id: number): Promise<void> {
    await http.delete(`${ENDPOINT}/${id}`);
  }

  static async getHistorial(codigo: string): Promise<VariablePlanilla[]> {
    const response = await http.get(`${ENDPOINT}/historial/${codigo}`);
    return response.data;
  }
}
